function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Typography } from '@material-ui/core';
import { faFacebookF, faGithub, faLinkedin, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Social from "../Social/index.js";
import { useStyles } from "./styles.js";
export const Footer = ({
  copyright,
  children,
  social,
  LanguageButtons
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("footer", {
    className: classes.container
  }, children, /*#__PURE__*/React.createElement("div", {
    className: classes.socialContainer
  }, social && social.map((item, idx) => /*#__PURE__*/React.createElement(Social, _extends({
    key: `social_${idx}`
  }, item)))), /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "subtitle2"
  }, copyright), LanguageButtons && LanguageButtons);
};
Footer.defaultProps = {
  social: [{
    name: 'facebook',
    to: 'https://www.facebook.com/BlackBoxVision',
    Icon: faFacebookF,
    background: 'rgb(63, 81, 181)'
  }, {
    name: 'twitter',
    to: 'https://twitter.com/blackbox_vision',
    Icon: faTwitter,
    background: 'rgb(33, 150, 243)'
  }, {
    name: 'github',
    to: 'https://github.com/BlackBoxVision',
    Icon: faGithub,
    background: '#000'
  }, {
    name: 'linkedin',
    to: 'https://www.linkedin.com/company/blackbox-vision/',
    Icon: faLinkedin,
    background: 'rgb(0, 119, 181)'
  }, {
    name: 'instagram',
    to: 'https://www.instagram.com/blackbox_vision/?hl=en',
    Icon: faInstagram,
    background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)'
  }]
};
Footer.displayName = 'Footer';
export default Footer;